import Dashboard from './../components/emails/Dashboard.vue'
import Show from './../components/emails/Show.vue'
import Create from './../components/emails/Create.vue'
import Import from './../components/emails/Import.vue'
import ExportEmails from './../components/emails/ExportEmails.vue'
import Edit from './../components/emails/Edit.vue'
import Root from './../components/Root.vue'
export default {
  path: 'email',
  component: Root,
  children: [
    {
      path: '',
      name: 'admin.emails.dashboard',
      component: Dashboard
    },
    {
      path: ':id/show',
      name: 'admin.emails.show',
      component: Show
    },
    {
      path: 'create',
      name: 'admin.emails.create',
      component: Create
    },
    {
      path: 'import',
      name: 'admin.emails.import',
      component: Import
    },
    {
      path: 'export',
      name: 'admin.emails.export-emails',
      component: ExportEmails
    },
    {
      path: ':id/update',
      name: 'admin.emails.edit',
      component: Edit
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/emails.js